<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.code" placeholder="版本号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="fetch">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="recordList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" width="60">
			</el-table-column>
			<el-table-column prop="code" label="版本号" width="150">
			</el-table-column>
			<el-table-column prop="url" label="下载地址" width="250">
				<template slot-scope="scope">
					<a :href="scope.row.url" target="_blank" class="buttonText">{{scope.row.url}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="fileSize" label="文件大小" width="250">
			</el-table-column>
			<el-table-column prop="description" label="描述" width="250">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" width="180">
			</el-table-column>
			<el-table-column label="操作" width="250" fixed="right">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :page-count="pageNo" :total="pageTotal" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="版本号" prop="code">
					<span>{{editForm.code}}</span>
				</el-form-item>
				<el-form-item label="描述" prop="description">
					<el-input v-model="editForm.description" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="下载地址" prop="url">
					<span>{{editForm.url}}</span>
				</el-form-item>
				<el-form-item label="文件大小" prop="fileSize">
					<span>{{editForm.fileSize}}</span>
				</el-form-item>
				<el-form-item label="MD5" prop="hash">
					<span>{{editForm.hash}}</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
				<el-form-item label="版本号" prop="code">
					<el-input v-model="addForm.code" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="描述" prop="description">
					<el-input v-model="addForm.description" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="apk文件" prop="url">
					<el-upload
						:disabled="addForm.fileList.length > 0"
						:headers="headers"
						:auto-upload="true"
						:action="uploadUrl"
						accept="application/vnd.android.package-archive"
						:file-list="addForm.fileList"
						:on-success="handleUploadSuccess"
						:on-error="handleUploadError"
						:limit="1">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">请上传apk格式文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="文件大小" prop="fileSize">
					<span>{{addForm.fileSize}}</span>
				</el-form-item>
				<el-form-item label="MD5" prop="hash">
					<span>{{addForm.hash}}</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { uploadUrl, getVersionListPage, removeVersion, batchRemoveVersion, editVersion, addVersion } from '../api/api';

	export default {
		data() {
			const token = sessionStorage.getItem('token')
			return {
				headers: { Authorization: `Bearer ${token}` },
				filters: {
					code: ''
				},
				recordList: [],
				pageTotal: 0,
				currentPage: 1,
				pageSize: 15,
				pageNo: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					code: [
						{ required: true, message: '请输入版本号', trigger: 'blur' }
					],
					url: [
						{ required: true, message: '请上传apk', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					code: '',
					description: '',
					url: '',
					fileSize: '',
					hash: '',
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					code: [
						{ required: true, message: '请输入分类名称', trigger: 'blur' }
					],
					url: [
						{ required: true, message: '请上传apk', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					code: '',
					description: '',
					url: '',
					fileSize: '',
					hash: '',
					fileList: [],
				},
				uploadUrl: uploadUrl
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val;
				this.fetch();
			},
			//获取版本列表
			async fetch() {
				let para = {
					code: this.filters.code,
					currentPage: this.currentPage,
					pageSize: this.pageSize,
				};
				this.listLoading = true;
				//NProgress.start();
				const res = await getVersionListPage(para)
				this.listLoading = false;
				//NProgress.done();
				if (res.data.status !== 200) {
					this.$message({
					message: res.data.message,
					type: 'warning'
					});
					return
				}
				this.currentPage = res.data.data.currentPage;
				this.pageSize = res.data.data.pageSize;
				this.pageNo = res.data.data.pageNo;
				this.pageTotal = res.data.data.pageTotal;
				this.recordList = res.data.data.recordList;
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					code: '',
					url: '',
					description: '',
					fileSize: '',
					hash: '',
					fileList: [],
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate(async (valid) => {
					if (valid) {
						this.editLoading = true;
						//NProgress.start();
						const para = Object.assign({}, this.editForm);
						const res = await editVersion(para)
						this.editLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['editForm'].resetFields();
						this.editFormVisible = false;
						this.fetch();
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate(async (valid) => {
					if (valid) {
						this.addLoading = true;
						//NProgress.start();
						let para = Object.assign({}, this.addForm);
						const res = await addVersion(para)
						this.addLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['addForm'].resetFields();
						this.addFormVisible = false;
						this.fetch();
					}
				});
			},
			handleUploadSuccess: function(res, file) {
				this.addForm.url = res.data.url
				this.addForm.fileSize = res.data.fields.fileSize
				this.addForm.hash = res.data.fields.hash
			},
			handleUploadError: function(error) {
				if (res.data.status !== 200) {
					this.$message({
					message: '上传失败',
					type: 'warning'
					});
					return
				}
				console.log(error);
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					const para = { id: row._id };
					const res = await removeVersion(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
						this.$message({
						message: res.data.message,
						type: 'warning'
						});
						return
					}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				const ids = this.sels.map(item => item._id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					const res = await batchRemoveVersion(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
						this.$message({
						message: res.data.message,
						type: 'warning'
						});
						return
					}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			}
		},
		mounted() {
			this.fetch();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Version.vue?77aa05b7